import { Info } from 'components/common/form/modules/Info'
import React from 'react'

const ChooseInventory: React.FC<{ [label: string]: any }> = (props: any) => {
    return <div
        className='sexyBlack'
        style={{
            width: '100%',
            textAlign: 'center',
            flexDirection: 'row',
            display: 'flex',
            margin: '5px',
            padding: '5px',
            borderRadius: '10px',
        }}>
        {
            props.soldOut || props.sellAfter ?
                <div style={{ width: '30%' }} /> :
                <div style={{ width: '30%', textAlign: 'left' }}>
                    {
                        screen.width >= 768 ?
                            <>
                                <button
                                    className={"button-minus"}
                                    onClick={e => props.subtract()}
                                    disabled={props.sellAfter || props.soldOut}
                                >
                                    -
                                </button>
                                <b className="ml-1 mr-1 pl-1 pr-1">{props.selected || 0}</b>
                                <button
                                    className={"button-plus"}
                                    onClick={e => props.add()}
                                    disabled={props.sellAfter || props.soldOut}
                                >
                                    +
                                </button>
                            </> :
                            <div style={{ textAlign: 'left' }}>
                                <div>
                                    <button
                                        className={"button-plus"}
                                        onClick={e => props.add()}
                                        disabled={props.sellAfter || props.soldOut}
                                    >
                                        +
                                    </button>
                                </div>
                                <div style={{ paddingLeft: '5px' }}>
                                    <b className="ml-1 mr-1 pl-1 pr-1">{props.selected || 0}</b>
                                </div>
                                <div>
                                    <button
                                        className={"button-minus"}
                                        onClick={e => props.subtract()}
                                        disabled={props.sellAfter || props.soldOut}
                                    >
                                        -
                                    </button>
                                </div>
                            </div>
                    }
                </div>
        }
        <div
            className={props.sellAfter || props.soldOut ? 'gray-text' : ''}
            style={{ width: '40%', textAlign: 'left', justifyContent: 'center', height: '100%', flexDirection: 'column'}}>
            <div>
                <h6 className={props.sellAfter || props.soldOut ? 'gray-text' : ''}>{props.name}</h6>
            </div>
            <div>
                {
                    props.sellAfter ?
                        <Info>
                            Sold After {props.precursor}
                        </Info> :
                        <Info>
                            {props.description}
                        </Info>
                }
            </div>
        </div>
        <div className={props.sellAfter || props.soldOut ? 'gray-text' : ''} style={{ width: '30%', justifyContent: 'center', height: '100%', flexDirection: 'column'}}>
            {
                props.soldOut ? 'SOLD OUT' : ('$' + (props.price / 100).toFixed(2))
            }
        </div>
    </div>
}

export default ChooseInventory;


// WEBPACK FOOTER //
// ./src/pages/campaign/SellPage/ChooseInventory.tsx